const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function postHistory(payload) {
  const res = await fetch(`${API}/history`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`POST history ${res.status}`);
  return res.json();
}

export async function fetchHistory(sessionId, limit = 100) {
  const url = `${API}/history?session_id=${encodeURIComponent(sessionId)}&limit=${limit}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`GET history ${res.status}`);
  return res.json();
}

export async function deleteHistory(sessionId) {
  const url = `${API}/history?session_id=${encodeURIComponent(sessionId)}`;
  const res = await fetch(url, { method: 'DELETE' });
  if (!res.ok) throw new Error(`DELETE history ${res.status}`);
  return res.json();
}
